// import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import skogforskLogo from "../assets/Skogforsk Logotyp_Original_Urskog RGB 750 px.png";
import { Button } from "../components/button";
import { Divider } from "../components/divider";
import { Heading, Subheading } from "../components/heading";
import { LanguageSwitcher } from "../components/LanguageSwitcher";
import { Text } from "../components/text";
import { useAuth } from "../context/useAuth";

function Login() {
  const { login, continueAsGuest } = useAuth();
  const { t } = useTranslation();
  const hasMsalConfig = Boolean(import.meta.env.FRONTEND_AUTH_CLIENT_ID && import.meta.env.FRONTEND_AUTH_AUTHORITY);

  return (
    <div className="flex flex-col items-center p-10 h-full w-full">
      <div className="absolute top-4 right-4">
        <LanguageSwitcher />
      </div>
      <div className="flex flex-col items-center m-5">
        <img src={skogforskLogo} alt="Logo" className=" w-28" />
        <Heading className="text-1xl">Skogforsklabbet</Heading>
      </div>
      <Subheading>{t("login.subtitle")}</Subheading>
      <Divider className="m-5" />

      <Text className="m-10">{t("login.description")}</Text>

      {!hasMsalConfig && import.meta.env.DEV && <Text className="m-4 max-w-xl text-center">{t("login.authNotConfigured")}</Text>}

      <Button className="btn-primary" onClick={login} disabled={!hasMsalConfig}>
        {t("login.button")}
      </Button>

      <button
        type="button"
        onClick={continueAsGuest}
        className="mt-4 text-sm text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-200 underline underline-offset-2 cursor-pointer"
      >
        {t("login.continueAsGuest")}
      </button>
    </div>
  );
}

export default Login;
